module.exports = __webpack_public_path__ + "img/04_ic_driver_black_62px.9844d36f.svg";